import { useEffect } from "react";

export const useDisableZoom = () => {
  useEffect(() => {
    // Configura meta viewport
    let meta = document.querySelector("meta[name=viewport]");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "viewport";
      document.head.appendChild(meta);
    }
    meta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no";

    // Adiciona CSS
    const style = document.createElement("style");
    style.id = "disable-zoom-styles";
    style.textContent = `
      * {
        touch-action: pan-y !important;
        -ms-touch-action: pan-y !important;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
      }
    `;
    document.head.appendChild(style);

    // Event handlers
    const preventGesture = (e) => e.preventDefault();

    let lastTouchEnd = 0;

    const handleTouchStart = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    const handleTouchMove = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    const handleTouchEnd = (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    };

    const handleWheel = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    const handleKeyDown = (e) => {
      if (
        e.ctrlKey &&
        (e.key === "+" || e.key === "-" || e.key === "0" || e.key === "=")
      ) {
        e.preventDefault();
      }
    };

    // Adiciona listeners
    ["gesturestart", "gesturechange", "gestureend"].forEach((event) => {
      document.addEventListener(event, preventGesture, { passive: false });
    });

    document.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    document.addEventListener("touchmove", handleTouchMove, { passive: false });
    document.addEventListener("touchend", handleTouchEnd, { passive: false });
    document.addEventListener("wheel", handleWheel, { passive: false });
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      ["gesturestart", "gesturechange", "gestureend"].forEach((event) => {
        document.removeEventListener(event, preventGesture);
      });

      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
      document.removeEventListener("wheel", handleWheel);
      document.removeEventListener("keydown", handleKeyDown);

      // Remove estilo
      const styleElement = document.getElementById("disable-zoom-styles");
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);
};
